/* eslint-disable no-param-reassign */
export function useSmoothScroll() {
    const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : ((t - 1) * ((2 * t) - 2) * ((2 * t) - 2)) + 1);

    const smoothScrollTo = (el, direction, endPosition, duration) => {
        const startTime = performance.now();
        const startPosition = direction === 'horizontal' ? el.scrollLeft : el.scrollTop;

        const step = () => {
            const elapsed = performance.now() - startTime;
            let position = endPosition;
            if (elapsed < duration) {
                position = startPosition + ((endPosition - startPosition) * easeInOutCubic(elapsed / duration));
                requestAnimationFrame(step);
            }
            if (direction === 'horizontal') el.scrollLeft = position;
            else el.scrollTop = position;
        };

        step();
    };

    return { smoothScrollTo };
}
